import type React from "react"
import { useTranslation } from "react-i18next"
import { Link as RouterLink } from "react-router"

import { RootPath } from "@/models/route"
import { APP_COMPANY_NAME } from "@/utils/constants"

import { Box, Button, Typography } from "@mui/material"

export const ResetPasswordSuccess: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          mb: 4,
        }}
      >
        {t("resetPassword.successMessage")}
      </Typography>
      <Button
        color="primary"
        component={RouterLink}
        to={`/${RootPath.SignIn}`}
        variant="contained"
      >
        {t("resetPassword.logInButton", { companyName: APP_COMPANY_NAME })}
      </Button>
    </Box>
  )
}
